import { NavTab } from "./NavTab";
import PropTypes from "prop-types";
import React from "react";

export default class NavTabs extends React.Component {
    render() {
        const items = this.props.tabs.map(it => (
                <NavTab key={it.id}
                        className={it.class}
                        name={it.name}
                        active={it.active}
                        icon={it.icon}
                        doSelect={() => this.props.doSelect(it.id)}
                />
        ));

        return <ul className="nav nav-pills nav-justified">{items}</ul>;
    }
}

NavTabs.propTypes = {
    doSelect: PropTypes.func.isRequired,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            class: PropTypes.string.isRequired,
            active: PropTypes.bool.isRequired,
        })
    ).isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/common/navtabs/NavTabs.js